import { render } from "./Companies.vue?vue&type=template&id=0915aa9a&scoped=true&ts=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"

import "./Companies.vue?vue&type=style&index=0&id=0915aa9a&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0915aa9a"]])

export default __exports__